import { api } from './client';
import type { Dealership } from '../types';

export const dealershipsApi = {
  list: () => api.get<{ dealerships: Dealership[] }>('/dealerships'),
  create: (name: string) => api.post<{ dealership: Dealership }>('/dealerships', { name }),
  update: (id: number, name: string) => api.put<{ dealership: Dealership }>(`/dealerships/${id}`, { name }),
  delete: (id: number) => api.delete<{ success: boolean }>(`/dealerships/${id}`),
};
